import PropTypes from 'prop-types'
import { createContext } from 'react'
import { useUserRole } from '@/data/hooks/useUserRole'
import { useAuthQuery } from '../hooks/useAuthQuery'

export const AuthContext = createContext(null)

/**
 * Cognito session state together with the permission profile from
 * GET /auth/me (primary_role, has_all_access, accessible_customer_ids).
 */
export function AuthProvider({ children }) {
  const auth = useAuthQuery()
  const role = useUserRole()

  const value = {
    user: auth.user,
    token: auth.token,
    isAuthenticated: auth.isAuthenticated,
    // Sign-in stays out of `loading` so the login form survives a rejected attempt
    loading: auth.loading || auth.isSigningOut,
    isSigningIn: auth.isSigningIn,
    signIn: (username, password) => auth.signIn({ username, password }),
    signOut: auth.signOut,
    getAuthToken: auth.getAuthToken,

    profile: role.userProfile,
    primaryRole: role.primaryRole,
    hasAllAccess: role.hasAllAccess,
    accessibleCustomerIds: role.accessibleCustomerIds,
    hasAnyAccess: role.hasAnyAccess(),
    isAdmin: role.isAdmin(),
    canAccessCustomer: role.canAccessCustomer,
    profileLoading: role.isLoading,
    profileError: role.error,
    refetchProfile: role.refetch,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
